export const DEVICE_TYPES = {
  CLASS_BOARD: '电子班牌',
  MORAL_MACHINE: '德育机'
};

export const normalizeDeviceType = (type) => (
  type === DEVICE_TYPES.MORAL_MACHINE ? DEVICE_TYPES.MORAL_MACHINE : DEVICE_TYPES.CLASS_BOARD
);

export const isClassBoard = (type) => normalizeDeviceType(type) === DEVICE_TYPES.CLASS_BOARD;

export const isMoralMachine = (type) => normalizeDeviceType(type) === DEVICE_TYPES.MORAL_MACHINE;

export const deviceTypeOptions = [
  { value: DEVICE_TYPES.CLASS_BOARD, label: DEVICE_TYPES.CLASS_BOARD },
  { value: DEVICE_TYPES.MORAL_MACHINE, label: DEVICE_TYPES.MORAL_MACHINE }
];
